export default __webpack_public_path__ + "5ea91cc.png";